export enum SFTPMainPages {
  browse = "browse",
  login = "login",
}

export enum NodeTypes {
  File = "file",
  Folder = "folder",
}

export interface TreeNode<T = string> {
  data: T;
  leaf: boolean;
  label?: string;
  name?: string;
  type?: string;
  size?: number;
  last_accessed_on?: string;
  last_modified_on?: string;
  key?: string;
  selected?: boolean;
}
